import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import { getProducerMainPageUrlBySlug } from 'modules/producers/helpers/producer-urls';
import { ProducerCategoryAggregationsInterface } from 'modules/producers/interfaces/producer-category-aggregations.interface';

export interface CategoryTreeInterface {
    id: string;
    url: string;
    name: string;
    amount: number;
    active: boolean;
}

export interface CategoriesTreeInterface {
    parent: CategoryTreeInterface;
    list: CategoryTreeInterface[];
}

function prepareItem(
    categoryId: string | null,
    item: ProducerCategoryAggregationsInterface,
    producerSlug: string,
    producerName: string,
    getUrl: useProducerUrlType
): CategoryTreeInterface {
    if (categoryId === item.id) {
        return {
            id: item.id,
            name: `${item.category.name} ${producerName}`,
            url: getProducerMainPageUrlBySlug(producerSlug),
            amount: item.count,
            active: true
        };
    } else {
        return {
            id: item.id,
            name: `${item.category.name} ${producerName}`,
            url: getUrl({ categoryId: item.id, categorySlug: item.category.slug, producerSlug, page: 1 }),
            amount: item.count,
            active: item.id === categoryId
        };
    }
}

export function prepareProducerCategoryTree(
    getUrl: useProducerUrlType,
    producerCategoryTree: ProducerCategoryAggregationsInterface[],
    producerSlug: string,
    producerName: string,
    categoryId: string | null
): CategoriesTreeInterface[] {
    const tree: Required<CategoriesTreeInterface>[] = [];

    producerCategoryTree?.map(item => {
        tree.push({
            parent: prepareItem(categoryId, item, producerSlug, producerName, getUrl),
            list: item?.children?.length
                ? item?.children?.map(itemChild => prepareItem(categoryId, itemChild, producerSlug, producerName, getUrl))
                    .sort((item1, item2) => item2.amount - item1.amount)
                : []
        });
    });

    return tree.sort((item1, item2) => item2.parent.amount - item1.parent.amount);
}
